import axios from 'axios'
import { API_BASE_URL_PRODUCTION, API_BASE_URL_TEST } from '../variables'
import { API_BASE_URL_FOR_OUTSOURCING } from '../variables'
const apiClient = axios.create({
  // baseURL: 'http://localhost:5000/api',
  baseURL: API_BASE_URL_PRODUCTION,
  // baseURL: API_BASE_URL_TEST,
  headers: {
    'Content-Type': 'application/json',
  },
})

export const apiClientForOutSourcing = axios.create({
  // baseURL: 'http://localhost:5502/api',
  baseURL: API_BASE_URL_FOR_OUTSOURCING,
  headers: {
    'Content-Type': 'application/json',
  },
})

export default apiClient
